/**
 * Skeleton — shimmer-block placeholder for loading states.
 * Wraps the global `.skeleton` CSS class so call sites stay declarative.
 */
export default function Skeleton({ className = '', rounded = 'rounded-md' }) {
  return <div className={`skeleton ${rounded} ${className}`} />;
}
